module.exports = __webpack_public_path__ + "images/icons_v2/alert-filled-3870fbb2.svg";